import LocalDatabase from './local-database';

export { LocalDatabase };

export default LocalDatabase;
